import { camelizeKeys } from 'humps';
import { adaptSkillTestingQuestion } from '../../stq/platformQuestion';

export { adaptSkillTestingQuestion };

/**
 * Adapt GraphQL hockey responses to the shapes Redux actions already expect
 * from the campaigns REST API.
 */

export function unwrapHockeyResult(result) {
  if (!result || typeof result !== 'object') {
    return result;
  }

  const { code, data } = result;

  if (code === 'noContest') {
    return { code: 'noContest' };
  }
  if (code === 'serverError') {
    return { code: 'serverError' };
  }
  if (typeof code === 'string' && code.length > 0) {
    const body = data && typeof data === 'object' && !Array.isArray(data) ? camelizeKeys(data) : {};
    return { ...body, code };
  }

  if (data == null) {
    return {};
  }
  return camelizeKeys(data);
}

/**
 * STQ GET/POST → legacy boolean / NotAllowed throw.
 * GraphQL: { passed, lockedOut }
 */
export function adaptStqStatus(status) {
  if (!status) {
    return false;
  }
  if (status.lockedOut) {
    const err = { code: 'NotAllowed' };
    throw err;
  }
  return Boolean(status.passed);
}

/**
 * Reminders GET → legacy { tnhcUserReminders: 'true'|'false' }.
 * Omit the key when GraphQL returns null (same as empty engagement prefs).
 */
export function adaptRemindersRead(optIn) {
  if (optIn === null || optIn === undefined) {
    return {};
  }
  return { tnhcUserReminders: optIn ? 'true' : 'false' };
}

/**
 * Username PATCH: hc.* codes were HTTP errors on REST; GraphQL returns them
 * in HockeyChallengeResult.code on a successful HTTP response.
 */
export function adaptHockeyMutationResult(result) {
  const adapted = unwrapHockeyResult(result);
  if (adapted?.code && String(adapted.code).includes('hc.')) {
    throw adapted;
  }
  if (adapted?.code === 'serverError') {
    throw adapted;
  }
  return adapted;
}

export function createUnauthorizedError() {
  const authErr = new Error('Unauthorized');
  authErr.status = 401;
  return authErr;
}

export function createServerError() {
  const serverErr = new Error('Server Error');
  serverErr.code = 500;
  return serverErr;
}

export function isUnauthenticatedGraphqlError(errors) {
  if (!Array.isArray(errors)) {
    return false;
  }
  return errors.some((err) => err?.extensions?.code === 'UNAUTHENTICATED');
}
